export default function toShortAddress(t) {
  if (!t) {
    return;
  }

  const limit = 6;

  return t
    .slice(0, limit)
    .concat("...")
    .concat(t.slice(t.length - limit, t.length));
}
